import Vue from 'vue';
import Router from 'vue-router';
import Top from './views/Top.vue';
import Works from './views/Works.vue';
import WorkContents01 from './views/WorkContents01.vue';
import WorkContents02 from './views/WorkContents02.vue';
import WorkContents03 from './views/WorkContents03.vue';
import WorkContents04 from './views/WorkContents04.vue';
import WorkContents05 from './views/WorkContents05.vue';
import WorkContents06 from './views/WorkContents06.vue';
import WorkContents07 from './views/WorkContents07.vue';
import About from './views/About.vue';
import Contact from './views/Contact.vue';
import Form from './views/Form.vue';
import Confirm from './views/Confirm.vue';
import Introduction from './views/Introduction.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Top
    },
    {
      path: '/works', 
      component: Works,
    },
    {
      path: '/work/workContents01', 
      component: WorkContents01,
    },
    {
      path: '/work/workContents02', 
      component: WorkContents02,
    },
    {
      path: '/work/workContents03', 
      component: WorkContents03,
    },
    {
      path: '/work/workContents04', 
      component: WorkContents04,
    },
    {
      path: '/work/workContents05', 
      component: WorkContents05,
    },
    {
      path: '/work/workContents06', 
      component: WorkContents06,
    },
    {
      path: '/work/workContents07', 
      component: WorkContents07,
    },
    {
      path: '/about',
      component: About
    },
    {
      path: '/contact',
      component: Contact,
      children: [
        {
          path: "/",
          component: Form
        },
        {
          path: "confirm",
          component: Confirm
        }
      ]
    },
    {
      path: '/introduction',
      component: Introduction
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});